import { TnADayPlanningScheduleDTO } from "src/models/tna/tna-day-planning-schedule/tna-day-planning-schedule-dto";
import { TnADayPlanningScheduleSTO } from "src/models/tna/tna-day-planning-schedule/tna-day-planning-schedule-sto";
import { BaseApiService } from "../base";

export class TnADayPlanningSchedulesApiService extends BaseApiService<
  TnADayPlanningScheduleDTO,
  TnADayPlanningScheduleSTO
> {
  constructor() {
    super({
      servicePath: "/TnASchedulePerDayPlanning",
      loadItemsPath: "/GetTnADayPlanningSchedules",
      saveItemsPath: "/SaveTnADayPlanningSchedule",
    });
  }
}
